// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","669":"component---src-templates-markdown-page-tsx","842":"component---src-pages-simple-index-tsx"}[chunkId] || chunkId) + "-" + {"231":"98727e5fd2b37666bea6","245":"eecc6d4488866272642a","669":"ba3bcffdd296f9546f8b","842":"e957f35228bf4f1fcce0"}[chunkId] + ".js";
};